module.exports = __webpack_public_path__ + "img/home-graphic-nl-BE-mobile.8f083f1f.png";